module.exports = __webpack_public_path__ + "static/media/Portugal_Uruguay.214966cc.jpeg";